import axios from 'axios';
import { Config } from '../utils/config';

export const axiosRetry = axios.create();

axiosRetry.interceptors.response.use(
    (response) => response,
    async (error) => {
        console.debug(error);
        const errorConfig = error.config;
        if (!errorConfig.retryCounter) {
            errorConfig.retryCounter = 1;
        } else {
            errorConfig.retryCounter++;
        }

        if (errorConfig.retryCounter > Config.ApiRetries) {
            return Promise.reject(error);
        }

        return new Promise((resolve) =>
            setTimeout(() => resolve(axiosRetry(errorConfig)), Config.ApiDelay),
        );
    },
);
